"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function FormChannelsNew(_a) {
    var user = _a.user, setUser = _a.setUser, setRole = _a.setRole;
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Forms.Title, null, "Nieuwe rol"),
        react_1.default.createElement(storybook_1.Forms.Field, { className: 'flex gap-4' },
            react_1.default.createElement(storybook_1.Users.FormRole, { value: user.role_id, setUser: setUser, setRole: setRole })));
}
exports.default = FormChannelsNew;
